import { useContext } from 'react';
import { QueryConfigContext } from '../context/query-config-context';

export function useQueryConfig<T>(): T {
  const { queryConfig } = useContext(QueryConfigContext);
  return queryConfig as T;
}
